import { FC } from 'react';
import IntervalType from '../IntervalType';
import SearchFormItem from './subpage/searchFormItem';
import { IntervalTypeProps } from '../IntervalType/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormIntervalTypeProps extends BaseSearchFormItemProps {
  /** IntervalType Props */
  intervalTypeProps?: IntervalTypeProps;
}
/** 类型+区间 */
export const SearchFormIntervalType: FC<SearchFormIntervalTypeProps> = props => {
  const {
    intervalTypeProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || intervalTypeProps?.disabled}
      name={name}
      label={label}
      rules={rules}
      validateTrigger={["onChange", "onBlur"]}
    >
      <IntervalType
        test-id={`${testId}-${name}`}
        disabledBorder
        {...intervalTypeProps}
        disabled={isDetail || intervalTypeProps?.disabled}
      />
    </SearchFormItem>
  );
};

SearchFormIntervalType.displayName = SearchFormItemEnum.SearchFormIntervalType;

export default SearchFormIntervalType;
